import React from 'react';
import { Alert, Button, Skeleton } from 'antd';
import dayjs from 'dayjs';
import SectionCard from '../finops/section-card';
import { useMonth } from '../../contexts/MonthContext';
import { useDataRange } from '../../contexts/DataRangeContext';
import { monthParam } from '../../hooks/wfm-query';

export function useWfmMonthParam() {
  const { month, isUserSelected } = useMonth();
  return monthParam(month, isUserSelected());
}

export function useWfmMonthReady() {
  const { loading, latestDataMonth } = useDataRange();
  const { month, isUserSelected } = useMonth();
  return !loading && (isUserSelected() || month.isSame(latestDataMonth, 'month'));
}

export const UPDATING_NOTE = 'Updating after a recent limit change…';

const KPI_CARDS = 5;

export function WfmPageSkeleton() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }} aria-busy="true">
      <div style={{ display: 'grid', gridTemplateColumns: `repeat(${KPI_CARDS}, 1fr)`, gap: 15 }}>
        {Array.from({ length: KPI_CARDS }, (_, i) => (
          <SectionCard key={i} style={{ padding: '20px 24px' }}><Skeleton active title={false} paragraph={{ rows: 2 }} /></SectionCard>
        ))}
      </div>
      <SectionCard><Skeleton active paragraph={{ rows: 8 }} /></SectionCard>
    </div>
  );
}

export function WfmLoadError({ error, noun }) {
  if (!error) return null;
  const missing = error.status === 404;
  return (
    <Alert
      type="error" showIcon
      message={missing ? `This ${noun} is not part of Delivery Teams.` : `Could not load this ${noun}.`}
      description={missing ? undefined : error.message}
    />
  );
}

export function WfmSnapshotNotice({ snapshotState }) {
  const { refreshing, stale, builtAt, pollExpired, retry } = snapshotState;
  if (refreshing) {
    return (
      <Alert
        type="info" showIcon role="status"
        message={pollExpired ? 'Limit figures are still updating.' : UPDATING_NOTE}
        action={pollExpired ? <Button size="small" onClick={retry}>Retry</Button> : undefined}
      />
    );
  }
  if (stale) {
    const when = builtAt && dayjs(builtAt).isValid() ? dayjs(builtAt).format('MMM D, YYYY h:mm A') : 'an earlier build';
    return <Alert type="warning" showIcon role="status" message={`Data as of ${when}; refresh failed`} />;
  }
  return null;
}
